import cn from "classnames"

import { Card, Descriptions } from "@/atoms"
import { Heading } from "@/molecules/Heading"

import styles from "./OverviewCard.module.scss"

import type { OverviewCardProps } from "."

export const OverviewCard = (props: OverviewCardProps) => {
  const { title, items, isLoading } = props

  return (
    <Card classNames={{ body: styles.body }}>
      <div className={styles.wrapper}>
        <Heading
          level={5}
          title={title}
          classes={{ container: styles.horizontal }}
        />
        <Descriptions
          grid
          isLoading={isLoading}
          items={items}
          classes={{ grid: cn(styles.horizontal, styles.grid) }}
        />
      </div>
    </Card>
  )
}
